import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { AnalyticsEvent } from "./analytics-event";

export function useGoogleAnalyticsEvent(): useGoogleAnalyticsEventReturn {
  return useLazyContext(GoogleAnalyticsEventContext);
}

export type useGoogleAnalyticsEventReturn = {
  submitEvent: (event: AnalyticsEvent) => void;
};

export const GoogleAnalyticsEventContext =
  createContext<LazyValue<useGoogleAnalyticsEventReturn>>(undefined);
